// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__8ZZWR","colMin":"styles_colMin__25LbI","colCheckbox":"styles_colCheckbox__3vqDY"};